/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as AuthWorkflowRulesRouteImport } from './routes/_auth/workflow-rules'
import { Route as AuthUsersRouteImport } from './routes/_auth/users'
import { Route as AuthUserProfileRouteImport } from './routes/_auth/user-profile'
import { Route as AuthTypeEditorRouteImport } from './routes/_auth/type-editor'
import { Route as AuthTemplatesRouteImport } from './routes/_auth/templates'
import { Route as AuthStatusEditorRouteImport } from './routes/_auth/status-editor'
import { Route as AuthRunReportRouteImport } from './routes/_auth/runReport'
import { Route as AuthReportsRouteImport } from './routes/_auth/reports'
import { Route as AuthReleaseNotesRouteImport } from './routes/_auth/release-notes'
import { Route as AuthPermissionsRouteImport } from './routes/_auth/permissions'
import { Route as AuthFieldGroupsRouteImport } from './routes/_auth/field-groups'
import { Route as AuthCustomersRouteImport } from './routes/_auth/customers'
import { Route as AuthCustomFieldsRouteImport } from './routes/_auth/custom-fields'
import { Route as AuthBatchUpdatesRouteImport } from './routes/_auth/batch-updates'
import { Route as AuthWorkflowRulesWorkflowruleIdRouteImport } from './routes/_auth/workflow-rules/$workflowruleId'
import { Route as AuthUsersUserIdRouteImport } from './routes/_auth/users/$userId'
import { Route as AuthTypeEditorTypeIdRouteImport } from './routes/_auth/type-editor/$typeId'
import { Route as AuthTicketTicketIdRouteImport } from './routes/_auth/ticket/$ticketId'
import { Route as AuthTemplatesTemplateIdRouteImport } from './routes/_auth/templates/$templateId'
import { Route as AuthStatusEditorSortOrderRouteImport } from './routes/_auth/status-editor/sort-order'
import { Route as AuthStatusEditorStatusIdRouteImport } from './routes/_auth/status-editor/$statusId'
import { Route as AuthReportsReportFilterRouteImport } from './routes/_auth/reports/$reportFilter'
import { Route as AuthPermissionsRoleIdRouteImport } from './routes/_auth/permissions/$roleId'
import { Route as AuthFieldGroupsFieldGroupIdRouteImport } from './routes/_auth/field-groups/$fieldGroupId'
import { Route as AuthCustomersCustomerIdRouteImport } from './routes/_auth/customers/$customerId'
import { Route as AuthCustomFieldsCustomFieldIdRouteImport } from './routes/_auth/custom-fields/$customFieldId'
import { Route as AuthBatchUpdatesBatchUpdateIdRouteImport } from './routes/_auth/batch-updates/$batchUpdateId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWorkflowRulesRoute = AuthWorkflowRulesRouteImport.update({
  id: '/workflow-rules',
  path: '/workflow-rules',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersRoute = AuthUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUserProfileRoute = AuthUserProfileRouteImport.update({
  id: '/user-profile',
  path: '/user-profile',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTypeEditorRoute = AuthTypeEditorRouteImport.update({
  id: '/type-editor',
  path: '/type-editor',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTemplatesRoute = AuthTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AuthRoute,
} as any)
const AuthStatusEditorRoute = AuthStatusEditorRouteImport.update({
  id: '/status-editor',
  path: '/status-editor',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRunReportRoute = AuthRunReportRouteImport.update({
  id: '/runReport',
  path: '/runReport',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsRoute = AuthReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReleaseNotesRoute = AuthReleaseNotesRouteImport.update({
  id: '/release-notes',
  path: '/release-notes',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPermissionsRoute = AuthPermissionsRouteImport.update({
  id: '/permissions',
  path: '/permissions',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFieldGroupsRoute = AuthFieldGroupsRouteImport.update({
  id: '/field-groups',
  path: '/field-groups',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCustomersRoute = AuthCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCustomFieldsRoute = AuthCustomFieldsRouteImport.update({
  id: '/custom-fields',
  path: '/custom-fields',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBatchUpdatesRoute = AuthBatchUpdatesRouteImport.update({
  id: '/batch-updates',
  path: '/batch-updates',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWorkflowRulesWorkflowruleIdRoute =
  AuthWorkflowRulesWorkflowruleIdRouteImport.update({
    id: '/$workflowruleId',
    path: '/$workflowruleId',
    getParentRoute: () => AuthWorkflowRulesRoute,
  } as any)
const AuthUsersUserIdRoute = AuthUsersUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => AuthUsersRoute,
} as any)
const AuthTypeEditorTypeIdRoute = AuthTypeEditorTypeIdRouteImport.update({
  id: '/$typeId',
  path: '/$typeId',
  getParentRoute: () => AuthTypeEditorRoute,
} as any)
const AuthTicketTicketIdRoute = AuthTicketTicketIdRouteImport.update({
  id: '/ticket/$ticketId',
  path: '/ticket/$ticketId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTemplatesTemplateIdRoute = AuthTemplatesTemplateIdRouteImport.update({
  id: '/$templateId',
  path: '/$templateId',
  getParentRoute: () => AuthTemplatesRoute,
} as any)
const AuthStatusEditorSortOrderRoute =
  AuthStatusEditorSortOrderRouteImport.update({
    id: '/sort-order',
    path: '/sort-order',
    getParentRoute: () => AuthStatusEditorRoute,
  } as any)
const AuthStatusEditorStatusIdRoute =
  AuthStatusEditorStatusIdRouteImport.update({
    id: '/$statusId',
    path: '/$statusId',
    getParentRoute: () => AuthStatusEditorRoute,
  } as any)
const AuthReportsReportFilterRoute = AuthReportsReportFilterRouteImport.update({
  id: '/$reportFilter',
  path: '/$reportFilter',
  getParentRoute: () => AuthReportsRoute,
} as any)
const AuthPermissionsRoleIdRoute = AuthPermissionsRoleIdRouteImport.update({
  id: '/$roleId',
  path: '/$roleId',
  getParentRoute: () => AuthPermissionsRoute,
} as any)
const AuthFieldGroupsFieldGroupIdRoute =
  AuthFieldGroupsFieldGroupIdRouteImport.update({
    id: '/$fieldGroupId',
    path: '/$fieldGroupId',
    getParentRoute: () => AuthFieldGroupsRoute,
  } as any)
const AuthCustomersCustomerIdRoute = AuthCustomersCustomerIdRouteImport.update({
  id: '/$customerId',
  path: '/$customerId',
  getParentRoute: () => AuthCustomersRoute,
} as any)
const AuthCustomFieldsCustomFieldIdRoute =
  AuthCustomFieldsCustomFieldIdRouteImport.update({
    id: '/$customFieldId',
    path: '/$customFieldId',
    getParentRoute: () => AuthCustomFieldsRoute,
  } as any)
const AuthBatchUpdatesBatchUpdateIdRoute =
  AuthBatchUpdatesBatchUpdateIdRouteImport.update({
    id: '/$batchUpdateId',
    path: '/$batchUpdateId',
    getParentRoute: () => AuthBatchUpdatesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/login': typeof LoginRoute
  '/batch-updates': typeof AuthBatchUpdatesRouteWithChildren
  '/custom-fields': typeof AuthCustomFieldsRouteWithChildren
  '/customers': typeof AuthCustomersRouteWithChildren
  '/field-groups': typeof AuthFieldGroupsRouteWithChildren
  '/permissions': typeof AuthPermissionsRouteWithChildren
  '/release-notes': typeof AuthReleaseNotesRoute
  '/reports': typeof AuthReportsRouteWithChildren
  '/runReport': typeof AuthRunReportRoute
  '/status-editor': typeof AuthStatusEditorRouteWithChildren
  '/templates': typeof AuthTemplatesRouteWithChildren
  '/type-editor': typeof AuthTypeEditorRouteWithChildren
  '/user-profile': typeof AuthUserProfileRoute
  '/users': typeof AuthUsersRouteWithChildren
  '/workflow-rules': typeof AuthWorkflowRulesRouteWithChildren
  '/': typeof AuthIndexRoute
  '/batch-updates/$batchUpdateId': typeof AuthBatchUpdatesBatchUpdateIdRoute
  '/custom-fields/$customFieldId': typeof AuthCustomFieldsCustomFieldIdRoute
  '/customers/$customerId': typeof AuthCustomersCustomerIdRoute
  '/field-groups/$fieldGroupId': typeof AuthFieldGroupsFieldGroupIdRoute
  '/permissions/$roleId': typeof AuthPermissionsRoleIdRoute
  '/reports/$reportFilter': typeof AuthReportsReportFilterRoute
  '/status-editor/$statusId': typeof AuthStatusEditorStatusIdRoute
  '/status-editor/sort-order': typeof AuthStatusEditorSortOrderRoute
  '/templates/$templateId': typeof AuthTemplatesTemplateIdRoute
  '/ticket/$ticketId': typeof AuthTicketTicketIdRoute
  '/type-editor/$typeId': typeof AuthTypeEditorTypeIdRoute
  '/users/$userId': typeof AuthUsersUserIdRoute
  '/workflow-rules/$workflowruleId': typeof AuthWorkflowRulesWorkflowruleIdRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/batch-updates': typeof AuthBatchUpdatesRouteWithChildren
  '/custom-fields': typeof AuthCustomFieldsRouteWithChildren
  '/customers': typeof AuthCustomersRouteWithChildren
  '/field-groups': typeof AuthFieldGroupsRouteWithChildren
  '/permissions': typeof AuthPermissionsRouteWithChildren
  '/release-notes': typeof AuthReleaseNotesRoute
  '/reports': typeof AuthReportsRouteWithChildren
  '/runReport': typeof AuthRunReportRoute
  '/status-editor': typeof AuthStatusEditorRouteWithChildren
  '/templates': typeof AuthTemplatesRouteWithChildren
  '/type-editor': typeof AuthTypeEditorRouteWithChildren
  '/user-profile': typeof AuthUserProfileRoute
  '/users': typeof AuthUsersRouteWithChildren
  '/workflow-rules': typeof AuthWorkflowRulesRouteWithChildren
  '/': typeof AuthIndexRoute
  '/batch-updates/$batchUpdateId': typeof AuthBatchUpdatesBatchUpdateIdRoute
  '/custom-fields/$customFieldId': typeof AuthCustomFieldsCustomFieldIdRoute
  '/customers/$customerId': typeof AuthCustomersCustomerIdRoute
  '/field-groups/$fieldGroupId': typeof AuthFieldGroupsFieldGroupIdRoute
  '/permissions/$roleId': typeof AuthPermissionsRoleIdRoute
  '/reports/$reportFilter': typeof AuthReportsReportFilterRoute
  '/status-editor/$statusId': typeof AuthStatusEditorStatusIdRoute
  '/status-editor/sort-order': typeof AuthStatusEditorSortOrderRoute
  '/templates/$templateId': typeof AuthTemplatesTemplateIdRoute
  '/ticket/$ticketId': typeof AuthTicketTicketIdRoute
  '/type-editor/$typeId': typeof AuthTypeEditorTypeIdRoute
  '/users/$userId': typeof AuthUsersUserIdRoute
  '/workflow-rules/$workflowruleId': typeof AuthWorkflowRulesWorkflowruleIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/batch-updates': typeof AuthBatchUpdatesRouteWithChildren
  '/_auth/custom-fields': typeof AuthCustomFieldsRouteWithChildren
  '/_auth/customers': typeof AuthCustomersRouteWithChildren
  '/_auth/field-groups': typeof AuthFieldGroupsRouteWithChildren
  '/_auth/permissions': typeof AuthPermissionsRouteWithChildren
  '/_auth/release-notes': typeof AuthReleaseNotesRoute
  '/_auth/reports': typeof AuthReportsRouteWithChildren
  '/_auth/runReport': typeof AuthRunReportRoute
  '/_auth/status-editor': typeof AuthStatusEditorRouteWithChildren
  '/_auth/templates': typeof AuthTemplatesRouteWithChildren
  '/_auth/type-editor': typeof AuthTypeEditorRouteWithChildren
  '/_auth/user-profile': typeof AuthUserProfileRoute
  '/_auth/users': typeof AuthUsersRouteWithChildren
  '/_auth/workflow-rules': typeof AuthWorkflowRulesRouteWithChildren
  '/_auth/': typeof AuthIndexRoute
  '/_auth/batch-updates/$batchUpdateId': typeof AuthBatchUpdatesBatchUpdateIdRoute
  '/_auth/custom-fields/$customFieldId': typeof AuthCustomFieldsCustomFieldIdRoute
  '/_auth/customers/$customerId': typeof AuthCustomersCustomerIdRoute
  '/_auth/field-groups/$fieldGroupId': typeof AuthFieldGroupsFieldGroupIdRoute
  '/_auth/permissions/$roleId': typeof AuthPermissionsRoleIdRoute
  '/_auth/reports/$reportFilter': typeof AuthReportsReportFilterRoute
  '/_auth/status-editor/$statusId': typeof AuthStatusEditorStatusIdRoute
  '/_auth/status-editor/sort-order': typeof AuthStatusEditorSortOrderRoute
  '/_auth/templates/$templateId': typeof AuthTemplatesTemplateIdRoute
  '/_auth/ticket/$ticketId': typeof AuthTicketTicketIdRoute
  '/_auth/type-editor/$typeId': typeof AuthTypeEditorTypeIdRoute
  '/_auth/users/$userId': typeof AuthUsersUserIdRoute
  '/_auth/workflow-rules/$workflowruleId': typeof AuthWorkflowRulesWorkflowruleIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/login'
    | '/batch-updates'
    | '/custom-fields'
    | '/customers'
    | '/field-groups'
    | '/permissions'
    | '/release-notes'
    | '/reports'
    | '/runReport'
    | '/status-editor'
    | '/templates'
    | '/type-editor'
    | '/user-profile'
    | '/users'
    | '/workflow-rules'
    | '/'
    | '/batch-updates/$batchUpdateId'
    | '/custom-fields/$customFieldId'
    | '/customers/$customerId'
    | '/field-groups/$fieldGroupId'
    | '/permissions/$roleId'
    | '/reports/$reportFilter'
    | '/status-editor/$statusId'
    | '/status-editor/sort-order'
    | '/templates/$templateId'
    | '/ticket/$ticketId'
    | '/type-editor/$typeId'
    | '/users/$userId'
    | '/workflow-rules/$workflowruleId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/batch-updates'
    | '/custom-fields'
    | '/customers'
    | '/field-groups'
    | '/permissions'
    | '/release-notes'
    | '/reports'
    | '/runReport'
    | '/status-editor'
    | '/templates'
    | '/type-editor'
    | '/user-profile'
    | '/users'
    | '/workflow-rules'
    | '/'
    | '/batch-updates/$batchUpdateId'
    | '/custom-fields/$customFieldId'
    | '/customers/$customerId'
    | '/field-groups/$fieldGroupId'
    | '/permissions/$roleId'
    | '/reports/$reportFilter'
    | '/status-editor/$statusId'
    | '/status-editor/sort-order'
    | '/templates/$templateId'
    | '/ticket/$ticketId'
    | '/type-editor/$typeId'
    | '/users/$userId'
    | '/workflow-rules/$workflowruleId'
  id:
    | '__root__'
    | '/_auth'
    | '/login'
    | '/_auth/batch-updates'
    | '/_auth/custom-fields'
    | '/_auth/customers'
    | '/_auth/field-groups'
    | '/_auth/permissions'
    | '/_auth/release-notes'
    | '/_auth/reports'
    | '/_auth/runReport'
    | '/_auth/status-editor'
    | '/_auth/templates'
    | '/_auth/type-editor'
    | '/_auth/user-profile'
    | '/_auth/users'
    | '/_auth/workflow-rules'
    | '/_auth/'
    | '/_auth/batch-updates/$batchUpdateId'
    | '/_auth/custom-fields/$customFieldId'
    | '/_auth/customers/$customerId'
    | '/_auth/field-groups/$fieldGroupId'
    | '/_auth/permissions/$roleId'
    | '/_auth/reports/$reportFilter'
    | '/_auth/status-editor/$statusId'
    | '/_auth/status-editor/sort-order'
    | '/_auth/templates/$templateId'
    | '/_auth/ticket/$ticketId'
    | '/_auth/type-editor/$typeId'
    | '/_auth/users/$userId'
    | '/_auth/workflow-rules/$workflowruleId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workflow-rules': {
      id: '/_auth/workflow-rules'
      path: '/workflow-rules'
      fullPath: '/workflow-rules'
      preLoaderRoute: typeof AuthWorkflowRulesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users': {
      id: '/_auth/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthUsersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/user-profile': {
      id: '/_auth/user-profile'
      path: '/user-profile'
      fullPath: '/user-profile'
      preLoaderRoute: typeof AuthUserProfileRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/type-editor': {
      id: '/_auth/type-editor'
      path: '/type-editor'
      fullPath: '/type-editor'
      preLoaderRoute: typeof AuthTypeEditorRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/templates': {
      id: '/_auth/templates'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof AuthTemplatesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/status-editor': {
      id: '/_auth/status-editor'
      path: '/status-editor'
      fullPath: '/status-editor'
      preLoaderRoute: typeof AuthStatusEditorRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/runReport': {
      id: '/_auth/runReport'
      path: '/runReport'
      fullPath: '/runReport'
      preLoaderRoute: typeof AuthRunReportRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports': {
      id: '/_auth/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthReportsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/release-notes': {
      id: '/_auth/release-notes'
      path: '/release-notes'
      fullPath: '/release-notes'
      preLoaderRoute: typeof AuthReleaseNotesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/permissions': {
      id: '/_auth/permissions'
      path: '/permissions'
      fullPath: '/permissions'
      preLoaderRoute: typeof AuthPermissionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/field-groups': {
      id: '/_auth/field-groups'
      path: '/field-groups'
      fullPath: '/field-groups'
      preLoaderRoute: typeof AuthFieldGroupsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/customers': {
      id: '/_auth/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AuthCustomersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/custom-fields': {
      id: '/_auth/custom-fields'
      path: '/custom-fields'
      fullPath: '/custom-fields'
      preLoaderRoute: typeof AuthCustomFieldsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/batch-updates': {
      id: '/_auth/batch-updates'
      path: '/batch-updates'
      fullPath: '/batch-updates'
      preLoaderRoute: typeof AuthBatchUpdatesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workflow-rules/$workflowruleId': {
      id: '/_auth/workflow-rules/$workflowruleId'
      path: '/$workflowruleId'
      fullPath: '/workflow-rules/$workflowruleId'
      preLoaderRoute: typeof AuthWorkflowRulesWorkflowruleIdRouteImport
      parentRoute: typeof AuthWorkflowRulesRoute
    }
    '/_auth/users/$userId': {
      id: '/_auth/users/$userId'
      path: '/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AuthUsersUserIdRouteImport
      parentRoute: typeof AuthUsersRoute
    }
    '/_auth/type-editor/$typeId': {
      id: '/_auth/type-editor/$typeId'
      path: '/$typeId'
      fullPath: '/type-editor/$typeId'
      preLoaderRoute: typeof AuthTypeEditorTypeIdRouteImport
      parentRoute: typeof AuthTypeEditorRoute
    }
    '/_auth/ticket/$ticketId': {
      id: '/_auth/ticket/$ticketId'
      path: '/ticket/$ticketId'
      fullPath: '/ticket/$ticketId'
      preLoaderRoute: typeof AuthTicketTicketIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/templates/$templateId': {
      id: '/_auth/templates/$templateId'
      path: '/$templateId'
      fullPath: '/templates/$templateId'
      preLoaderRoute: typeof AuthTemplatesTemplateIdRouteImport
      parentRoute: typeof AuthTemplatesRoute
    }
    '/_auth/status-editor/sort-order': {
      id: '/_auth/status-editor/sort-order'
      path: '/sort-order'
      fullPath: '/status-editor/sort-order'
      preLoaderRoute: typeof AuthStatusEditorSortOrderRouteImport
      parentRoute: typeof AuthStatusEditorRoute
    }
    '/_auth/status-editor/$statusId': {
      id: '/_auth/status-editor/$statusId'
      path: '/$statusId'
      fullPath: '/status-editor/$statusId'
      preLoaderRoute: typeof AuthStatusEditorStatusIdRouteImport
      parentRoute: typeof AuthStatusEditorRoute
    }
    '/_auth/reports/$reportFilter': {
      id: '/_auth/reports/$reportFilter'
      path: '/$reportFilter'
      fullPath: '/reports/$reportFilter'
      preLoaderRoute: typeof AuthReportsReportFilterRouteImport
      parentRoute: typeof AuthReportsRoute
    }
    '/_auth/permissions/$roleId': {
      id: '/_auth/permissions/$roleId'
      path: '/$roleId'
      fullPath: '/permissions/$roleId'
      preLoaderRoute: typeof AuthPermissionsRoleIdRouteImport
      parentRoute: typeof AuthPermissionsRoute
    }
    '/_auth/field-groups/$fieldGroupId': {
      id: '/_auth/field-groups/$fieldGroupId'
      path: '/$fieldGroupId'
      fullPath: '/field-groups/$fieldGroupId'
      preLoaderRoute: typeof AuthFieldGroupsFieldGroupIdRouteImport
      parentRoute: typeof AuthFieldGroupsRoute
    }
    '/_auth/customers/$customerId': {
      id: '/_auth/customers/$customerId'
      path: '/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof AuthCustomersCustomerIdRouteImport
      parentRoute: typeof AuthCustomersRoute
    }
    '/_auth/custom-fields/$customFieldId': {
      id: '/_auth/custom-fields/$customFieldId'
      path: '/$customFieldId'
      fullPath: '/custom-fields/$customFieldId'
      preLoaderRoute: typeof AuthCustomFieldsCustomFieldIdRouteImport
      parentRoute: typeof AuthCustomFieldsRoute
    }
    '/_auth/batch-updates/$batchUpdateId': {
      id: '/_auth/batch-updates/$batchUpdateId'
      path: '/$batchUpdateId'
      fullPath: '/batch-updates/$batchUpdateId'
      preLoaderRoute: typeof AuthBatchUpdatesBatchUpdateIdRouteImport
      parentRoute: typeof AuthBatchUpdatesRoute
    }
  }
}

interface AuthBatchUpdatesRouteChildren {
  AuthBatchUpdatesBatchUpdateIdRoute: typeof AuthBatchUpdatesBatchUpdateIdRoute
}

const AuthBatchUpdatesRouteChildren: AuthBatchUpdatesRouteChildren = {
  AuthBatchUpdatesBatchUpdateIdRoute: AuthBatchUpdatesBatchUpdateIdRoute,
}

const AuthBatchUpdatesRouteWithChildren =
  AuthBatchUpdatesRoute._addFileChildren(AuthBatchUpdatesRouteChildren)

interface AuthCustomFieldsRouteChildren {
  AuthCustomFieldsCustomFieldIdRoute: typeof AuthCustomFieldsCustomFieldIdRoute
}

const AuthCustomFieldsRouteChildren: AuthCustomFieldsRouteChildren = {
  AuthCustomFieldsCustomFieldIdRoute: AuthCustomFieldsCustomFieldIdRoute,
}

const AuthCustomFieldsRouteWithChildren =
  AuthCustomFieldsRoute._addFileChildren(AuthCustomFieldsRouteChildren)

interface AuthCustomersRouteChildren {
  AuthCustomersCustomerIdRoute: typeof AuthCustomersCustomerIdRoute
}

const AuthCustomersRouteChildren: AuthCustomersRouteChildren = {
  AuthCustomersCustomerIdRoute: AuthCustomersCustomerIdRoute,
}

const AuthCustomersRouteWithChildren = AuthCustomersRoute._addFileChildren(
  AuthCustomersRouteChildren,
)

interface AuthFieldGroupsRouteChildren {
  AuthFieldGroupsFieldGroupIdRoute: typeof AuthFieldGroupsFieldGroupIdRoute
}

const AuthFieldGroupsRouteChildren: AuthFieldGroupsRouteChildren = {
  AuthFieldGroupsFieldGroupIdRoute: AuthFieldGroupsFieldGroupIdRoute,
}

const AuthFieldGroupsRouteWithChildren = AuthFieldGroupsRoute._addFileChildren(
  AuthFieldGroupsRouteChildren,
)

interface AuthPermissionsRouteChildren {
  AuthPermissionsRoleIdRoute: typeof AuthPermissionsRoleIdRoute
}

const AuthPermissionsRouteChildren: AuthPermissionsRouteChildren = {
  AuthPermissionsRoleIdRoute: AuthPermissionsRoleIdRoute,
}

const AuthPermissionsRouteWithChildren = AuthPermissionsRoute._addFileChildren(
  AuthPermissionsRouteChildren,
)

interface AuthReportsRouteChildren {
  AuthReportsReportFilterRoute: typeof AuthReportsReportFilterRoute
}

const AuthReportsRouteChildren: AuthReportsRouteChildren = {
  AuthReportsReportFilterRoute: AuthReportsReportFilterRoute,
}

const AuthReportsRouteWithChildren = AuthReportsRoute._addFileChildren(
  AuthReportsRouteChildren,
)

interface AuthStatusEditorRouteChildren {
  AuthStatusEditorStatusIdRoute: typeof AuthStatusEditorStatusIdRoute
  AuthStatusEditorSortOrderRoute: typeof AuthStatusEditorSortOrderRoute
}

const AuthStatusEditorRouteChildren: AuthStatusEditorRouteChildren = {
  AuthStatusEditorStatusIdRoute: AuthStatusEditorStatusIdRoute,
  AuthStatusEditorSortOrderRoute: AuthStatusEditorSortOrderRoute,
}

const AuthStatusEditorRouteWithChildren =
  AuthStatusEditorRoute._addFileChildren(AuthStatusEditorRouteChildren)

interface AuthTemplatesRouteChildren {
  AuthTemplatesTemplateIdRoute: typeof AuthTemplatesTemplateIdRoute
}

const AuthTemplatesRouteChildren: AuthTemplatesRouteChildren = {
  AuthTemplatesTemplateIdRoute: AuthTemplatesTemplateIdRoute,
}

const AuthTemplatesRouteWithChildren = AuthTemplatesRoute._addFileChildren(
  AuthTemplatesRouteChildren,
)

interface AuthTypeEditorRouteChildren {
  AuthTypeEditorTypeIdRoute: typeof AuthTypeEditorTypeIdRoute
}

const AuthTypeEditorRouteChildren: AuthTypeEditorRouteChildren = {
  AuthTypeEditorTypeIdRoute: AuthTypeEditorTypeIdRoute,
}

const AuthTypeEditorRouteWithChildren = AuthTypeEditorRoute._addFileChildren(
  AuthTypeEditorRouteChildren,
)

interface AuthUsersRouteChildren {
  AuthUsersUserIdRoute: typeof AuthUsersUserIdRoute
}

const AuthUsersRouteChildren: AuthUsersRouteChildren = {
  AuthUsersUserIdRoute: AuthUsersUserIdRoute,
}

const AuthUsersRouteWithChildren = AuthUsersRoute._addFileChildren(
  AuthUsersRouteChildren,
)

interface AuthWorkflowRulesRouteChildren {
  AuthWorkflowRulesWorkflowruleIdRoute: typeof AuthWorkflowRulesWorkflowruleIdRoute
}

const AuthWorkflowRulesRouteChildren: AuthWorkflowRulesRouteChildren = {
  AuthWorkflowRulesWorkflowruleIdRoute: AuthWorkflowRulesWorkflowruleIdRoute,
}

const AuthWorkflowRulesRouteWithChildren =
  AuthWorkflowRulesRoute._addFileChildren(AuthWorkflowRulesRouteChildren)

interface AuthRouteChildren {
  AuthBatchUpdatesRoute: typeof AuthBatchUpdatesRouteWithChildren
  AuthCustomFieldsRoute: typeof AuthCustomFieldsRouteWithChildren
  AuthCustomersRoute: typeof AuthCustomersRouteWithChildren
  AuthFieldGroupsRoute: typeof AuthFieldGroupsRouteWithChildren
  AuthPermissionsRoute: typeof AuthPermissionsRouteWithChildren
  AuthReleaseNotesRoute: typeof AuthReleaseNotesRoute
  AuthReportsRoute: typeof AuthReportsRouteWithChildren
  AuthRunReportRoute: typeof AuthRunReportRoute
  AuthStatusEditorRoute: typeof AuthStatusEditorRouteWithChildren
  AuthTemplatesRoute: typeof AuthTemplatesRouteWithChildren
  AuthTypeEditorRoute: typeof AuthTypeEditorRouteWithChildren
  AuthUserProfileRoute: typeof AuthUserProfileRoute
  AuthUsersRoute: typeof AuthUsersRouteWithChildren
  AuthWorkflowRulesRoute: typeof AuthWorkflowRulesRouteWithChildren
  AuthIndexRoute: typeof AuthIndexRoute
  AuthTicketTicketIdRoute: typeof AuthTicketTicketIdRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthBatchUpdatesRoute: AuthBatchUpdatesRouteWithChildren,
  AuthCustomFieldsRoute: AuthCustomFieldsRouteWithChildren,
  AuthCustomersRoute: AuthCustomersRouteWithChildren,
  AuthFieldGroupsRoute: AuthFieldGroupsRouteWithChildren,
  AuthPermissionsRoute: AuthPermissionsRouteWithChildren,
  AuthReleaseNotesRoute: AuthReleaseNotesRoute,
  AuthReportsRoute: AuthReportsRouteWithChildren,
  AuthRunReportRoute: AuthRunReportRoute,
  AuthStatusEditorRoute: AuthStatusEditorRouteWithChildren,
  AuthTemplatesRoute: AuthTemplatesRouteWithChildren,
  AuthTypeEditorRoute: AuthTypeEditorRouteWithChildren,
  AuthUserProfileRoute: AuthUserProfileRoute,
  AuthUsersRoute: AuthUsersRouteWithChildren,
  AuthWorkflowRulesRoute: AuthWorkflowRulesRouteWithChildren,
  AuthIndexRoute: AuthIndexRoute,
  AuthTicketTicketIdRoute: AuthTicketTicketIdRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
